import $ from "jquery";
import Glide from "@glidejs/glide";
import { siblings } from '@glidejs/glide/src/utils/dom';
var CustomActiveClass = function (Glide, Components, Events) {
    var Component = {
        mount: function () {
            this.changeActiveSlide();
        },
        changeActiveSlide: function () {
            var selector = Glide.selector;
            var slide = Components.Html.slides[Glide.index];
            selector.classList.remove("has-next", "has-prev");
            slide.classList.remove('is-next', 'is-prev');
            slide.classList.add('is-active');
            siblings(slide).forEach(function (sibling) {
                sibling.classList.remove('is-active', 'is-next', 'is-prev');
            });
            if (slide.nextElementSibling) {
                selector.classList.add("has-next");
                slide.nextElementSibling.classList.add('is-next');
            }
            if (slide.previousElementSibling) {
                selector.classList.add("has-prev");
                slide.previousElementSibling.classList.add('is-prev');
            }
        }
    };
    Events.on('run', function () {
        Component.changeActiveSlide();
    });
    return Component;
};
export function carouselWrapper() {
    if ($('.carouselWrapper').length) {
        $('.carouselWrapper').each(function (k, e) {
            var gap = $(e).attr("data-gap") !== void 0 ? $(e).attr("data-gap") : 50;
            var mobileGap = $(e).attr("data-mobile-gap") !== void 0 ? $(e).attr("data-mobile-gap") : 20;
            var view = $(e).attr("data-view") !== void 0 ? $(e).attr("data-view") : 2.5;
            var mobileView = $(e).attr("data-mobile-view") !== void 0 ? $(e).attr("data-mobile-view") : 1.3;
            var type = $(e).attr("data-type") !== void 0 ? $(e).attr("data-type") : "slider";
            var focus = $(e).attr("data-focus") !== void 0 ? $(e).attr("data-focus") : 0;
            var peek = $(e).attr("data-peek") !== void 0 ? $(e).attr("data-peek") : 0;
            var bound = $(e).attr("data-bound") !== void 0 ? $(e).attr("data-bound") : false;
            var lgGap = $(e).attr("data-lg-gap") !== void 0 ? $(e).attr("data-lg-gap") : gap;
            var lgView = $(e).attr("data-lg-view") !== void 0 ? $(e).attr("data-lg-view") : view;
            var lgPeek = $(e).attr("data-lg-peek") !== void 0 ? $(e).attr("data-lg-peek") : peek;
            var mdGap = $(e).attr("data-md-gap") !== void 0 ? $(e).attr("data-md-gap") : lgGap;
            var mdView = $(e).attr("data-md-view") !== void 0 ? $(e).attr("data-md-view") : lgView;
            var mdPeek = $(e).attr("data-md-peek") !== void 0 ? $(e).attr("data-md-peek") : lgPeek;
            var smGap = $(e).attr("data-sm-gap") !== void 0 ? $(e).attr("data-sm-gap") : mdGap;
            var smView = $(e).attr("data-sm-view") !== void 0 ? $(e).attr("data-sm-view") : mdView;
            var smPeek = $(e).attr("data-sm-peek") !== void 0 ? $(e).attr("data-sm-peek") : mdPeek;
            var xsGap = $(e).attr("data-xs-gap") !== void 0 ? $(e).attr("data-xs-gap") : smGap;
            var xsView = $(e).attr("data-xs-view") !== void 0 ? $(e).attr("data-xs-view") : smView;
            var xsPeek = $(e).attr("data-xs-peek") !== void 0 ? $(e).attr("data-xs-peek") : smPeek;
            var xsFocusAt = $(e).attr("data-xs-focus") !== void 0 ? $(e).attr("data-xs-focus") : "center";
            var customControl = $(e).attr("data-custom-control") !== void 0 ? $(e).attr("data-custom-control") : false;
            var glide = new Glide(e, {
                type: type,
                focusAt: focus,
                perView: view,
                gap: gap,
                startAt: 0,
                bound: true,
                peek: peek,
                breakpoints: {
                    1280: {
                        gap: lgGap,
                        perView: lgView,
                        peek: lgPeek
                    },
                    1050: {
                        gap: mdGap,
                        perView: mdView,
                        peek: mdPeek
                    },
                    780: {
                        gap: smGap,
                        peek: smPeek,
                        perView: smView
                    },
                    568: {
                        // peek: 40,
                        focusAt: xsFocusAt,
                        gap: xsGap,
                        peek: 0,
                        perView: xsView
                    }
                }
            });
            glide.mount({
                'CustomActiveClass': CustomActiveClass
            });
            if (customControl != false) {
                $(customControl).on("click", "button", function (e) {
                    e.preventDefault();
                    glide.go($(e.currentTarget).attr("data-glide-dir"));
                });
            }
            $(e).find(".glide__slide").on('click', function (e) {
                // if ($(e.currentTarget).hasClass("is-next")) {glide.go('>');}
                // if ($(e.currentTarget).hasClass("is-prev")) {glide.go('<');}
                // var ind = parseInt(e.currentTarget.getAttribute('data-index'))
                // if (ind === 0 || ind > 0) {
                //   glide.go('='+ind)    
                // }
            });
        });
    }
}
